import { TYPE_COLLECTION } from './options/input-types';
import { isIn, isNull } from './operators/collection';
import { getApiFilterFromFilter, filterTypeToApiFilterMap } from './api-filter-builder';

// could put these methods as generator functions into the options themselves?
export const generateApiCollectionFilter = (id, value, operator) => {
  const fallbackOperator = value ? isIn : isNull;
  const operatorWithFallback = operator || fallbackOperator;

  const filter = { id, value, operator: operatorWithFallback };
  return {
    collectionFilterName: filterTypeToApiFilterMap[TYPE_COLLECTION].filterName,
    apiFilter: getApiFilterFromFilter(filter, TYPE_COLLECTION),
  };
};
